var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMxn = function SvgMxn(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5513_107362",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 16,
    height: 12
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 2,
    width: 16,
    height: 12,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5513_107362)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2H16V14H11V2Z",
    fill: "#D9071E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2H6V14H0V2Z",
    fill: "#006923"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2H11V14H5V2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19213 5.95667C7.19213 5.95667 6.84873 6.22299 6.91295 6.50693C6.97717 6.79087 7.65392 6.50693 7.57211 6.2318C7.4903 5.95667 7.19213 5.95667 7.19213 5.95667Z",
    fill: "#FCCA3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66779 6.63402C6.41085 6.63402 6.30373 6.4199 6.35688 6.19232C6.38528 6.0707 6.45905 5.91641 6.57941 5.71594L7.00808 5.97332C6.96219 6.04976 6.92561 6.1161 6.89848 6.17087C6.98835 6.19741 7.07694 6.23685 7.14904 6.28433C7.3825 6.43806 7.46843 6.71198 7.21814 6.91499C7.1697 6.95428 7.0911 7.08824 7.04771 7.21688C7.16713 7.22354 7.25249 7.2415 7.33118 7.28804C7.55217 7.41877 7.53138 7.65717 7.36309 7.84128C7.24381 7.97177 7.08454 8.07762 6.9345 8.13184C6.68487 8.22205 6.41779 8.1875 6.41779 7.86792L6.41773 7.86558C6.41724 7.85257 6.4164 7.83032 6.52788 7.8278C6.33766 7.8251 6.29695 7.7244 6.27323 7.54509C6.26722 7.49967 6.2648 7.45644 6.26146 7.36315C6.25933 7.3027 6.25933 7.3027 6.25656 7.24333L6.25656 7.24332L6.25575 7.23017C6.25199 7.17245 6.24939 7.13248 6.37878 7.13248H6.08875V6.63248H6.37878C6.54328 6.63248 6.63419 6.68803 6.68628 6.80288C6.71528 6.7508 6.74683 6.70177 6.78003 6.65781C6.73821 6.64334 6.69579 6.63402 6.66779 6.63402ZM6.98626 7.51225L6.99404 7.50393C6.99319 7.50486 6.99235 7.50605 6.99155 7.50747L6.98626 7.51225ZM6.76794 7.6605C6.76738 7.66062 6.7671 7.66068 6.76721 7.66064L6.76804 7.66047L6.76794 7.6605ZM6.76788 7.47203L6.76891 7.47952L6.76728 7.46504L6.76788 7.47203ZM6.5496 7.82756L6.52788 7.8278L6.542 7.82752L6.5496 7.82756Z",
    fill: "#A8AC71"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.63328 8.20141C9.63328 8.20141 10.0958 6.83074 9.36059 6.12122C8.6254 5.41171 7.77585 5.45919 7.77585 5.45919C7.77585 5.45919 7.5312 5.64096 7.77585 5.77959C8.0205 5.91821 7.918 6.05114 7.918 6.05114C7.918 6.05114 7.50828 5.63512 7.23629 5.87817C6.9643 6.12122 7.49019 6.08423 7.43452 6.26724C7.37885 6.45025 7.143 7.26278 7.48763 7.673C7.83227 8.08323 7.16179 7.9942 7.29816 7.9942C7.43452 7.9942 7.918 8.08969 7.918 7.9942C7.918 7.89871 8.08608 8.36544 8.22993 8.36544C8.37377 8.36544 8.4848 8.20141 8.4848 8.20141C8.4848 8.20141 8.68644 8.36544 8.8093 8.36544C8.93216 8.36544 9.36059 8.2581 9.36059 8.2581L8.55085 7.57584C8.55085 7.57584 8.59967 7.2749 8.4848 7.20977C8.36993 7.14464 9.40569 7.78699 9.4868 7.9942C9.56791 8.20141 9.63328 8.20141 9.63328 8.20141Z",
    fill: "#8F4620"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.53329 7.86329C5.53329 7.86329 5.60836 7.62401 5.68874 7.6074C5.75838 7.59301 5.90481 7.72207 5.90481 7.72207C6.16493 9.167 6.79389 9.73136 7.83752 9.73136C8.89343 9.73136 9.53339 9.30252 9.90685 7.96989C9.90685 7.96989 10.1054 7.76714 10.1754 7.78968C10.2517 7.81422 10.3473 8.08246 10.3473 8.08246C10.2517 9.64077 9.12665 10.5645 7.85482 10.5645C6.57072 10.5645 5.52226 9.52947 5.53329 7.86329Z",
    fill: "#9FAB2F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.66711 8.82819C6.66711 8.82819 8.16929 9.14686 8.76221 9.14686C9.35513 9.14686 8.24198 9.63076 7.80765 9.63076C7.37331 9.63076 6.66711 8.82819 6.66711 8.82819Z",
    fill: "#2FC2DC"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.33337,
    y: 9.04996,
    width: 1,
    height: 0.535714,
    rx: 0.0833333,
    fill: "#F9AA51"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.08777 8.06793L6.49708 7.78076C7.0298 8.54007 7.82645 8.78987 8.94066 8.52916L9.05458 9.016C7.75207 9.32078 6.74526 9.00509 6.08777 8.06793Z",
    fill: "#259485"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.2957 8.17508C8.2957 8.17508 7.68887 8.49452 7.89115 8.49452C8.09342 8.49452 8.88507 8.65424 8.73103 8.49452C8.57699 8.3348 8.2957 8.17508 8.2957 8.17508Z",
    fill: "#FCCA3D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.57826 7.79409C7.57826 7.79409 7.46296 7.46106 7.22302 7.46106C6.98307 7.46106 7.0508 7.73425 6.93542 7.73425C6.82003 7.73425 7.04293 7.92649 7.14228 7.92649C7.24163 7.92649 7.57826 7.79409 7.57826 7.79409Z",
    fill: "#FCCA3D"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMxn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "MXN.20fb518400ceaa004318d555c37c1a69.svg";